/* eslint-disable import/order */
import React from 'react'
import { Box, Typography, makeStyles } from '@material-ui/core'

import colors from '../../../../assets/colors'

const useStyles = makeStyles(theme => ({
  section: {
    width: '100%',
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    marginBottom: `${theme.spacing(1)}px`,
  },
  bar: {
    width: '4px',
    minHeight: '20px',
    alignSelf: 'stretch',
    borderRadius: '4px',
    backgroundColor: colors.secondary,
  },
  title: {
    fontSize: '15px',
    fontWeight: 700,
    lineHeight: '20px',
    letterSpacing: '.02em',
    textTransform: 'uppercase',
    color: colors.primary,
  },
  caption: {
    fontSize: '12px',
    lineHeight: '18px',
    color: colors.textPrimary,
    marginTop: '2px',
  },
}))

const FormSection = ({ title, caption, children }) => {
  const classes = useStyles()

  return (
    <Box className={classes.section}>
      <Box className={classes.header}>
        <Box className={classes.bar} />
        <Box>
          <Typography className={classes.title}>{title}</Typography>
          {caption && (
            <Typography className={classes.caption}>{caption}</Typography>
          )}
        </Box>
      </Box>

      {children}
    </Box>
  )
}

export default FormSection
